<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">状态：</span>
                <a-select v-model="seach.status" class="seachs" allowClear>
                    <a-select-option :value="item.value" :key="item.value" v-for="item in seachList ">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList"><span class="name">更新日期：</span>
                <a-range-picker class="seachs" v-model="seach.update_time" :allowClear="false" :showTime="false"
                                format="YYYY-MM-DD"/>
            </div>
            <div class="seachList"><span class="name">关键字：</span>
                <a-input placeholder="" class="seachs" v-model="seach.name"/>
            </div>
            <div class="seachList  ">
                <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                    查询
                </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>

        </div>

        <div  >
            <a-button class="top_btn" type="primary" @click="add('')" v-has="'btn_add'"  >
                添加活动
            </a-button>
<!--            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"-->
<!--                      @click="editLanguage('status','1')" v-has="'btn_status_top'">-->
<!--                发布-->
<!--            </a-button>-->
<!--            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"-->
<!--                      @click="editLanguage('status','0')" v-has="'btn_status_top'">-->
<!--                取消发布-->
<!--      :disabled="!hasSelected"       </a-button>-->
<!--            <a-popconfirm-->
<!--                    title="此操作将永久删除, 是否继续?"-->
<!--                    ok-text="确定"-->
<!--                    cancel-text="取消"-->
<!--                    @confirm="editLanguage('','5')"-->
<!--                    @cancel="()=>{}"-->

<!--            >-->
                <a-button  type="primary" @click="deles" v-has="'btn_delete'">
                    删除
                </a-button>
<!--            </a-popconfirm>-->

            <span style="margin-left: 8px">
                <template v-if="hasSelected">
                  {{ `选中 ${selectedRowKeys.length} 项` }}
                </template>
            </span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :locale="{emptyText:emptyText}">
          <span slot="activity_cover" slot-scope="text, record">
                 <img  src="@/assets/tem2.png" alt="" @click="()=>{visibleImg=true;tableImg=record.activity_cover}" style="width:30px;display: block;cursor: pointer">
      </span>
            <span slot="status" slot-scope="text, record">
                <span>{{text==1?"发布":"草稿"}}</span>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="add(text.id ) " v-has="'btn_edit'">编辑<a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
      <a-modal  :footer="null"
                title="查看大图"
                :visible="visibleImg"
                @cancel="()=>{visibleImg=false}"
      >
        <img :src="tableImg" alt="" style="width: 100%;display: block">
      </a-modal>

      <a-modal v-model="visibleModal" title=" " class="modal" width="416px" height="163px">
        <p><a-icon type="question-circle" style="color: #2e9ad0;font-size: 22px;margin-right: 16px" /><span style="font-size: 16px">确定要删除吗？</span></p>
        <template slot="footer">
          <a-button key="submit" type="primary" @click="editLanguage('','5')">
            确定
          </a-button>
          <a-button  key="back"    @click="()=>{ visibleModal=false  }">
            关闭
          </a-button>
        </template>
      </a-modal>
    </div>

</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import {changStatus, removeById,orderList} from "../../utils/utils"
    import Vue from "vue"
    const columns = [
        {
        title: "图片",
        dataIndex: "activity_cover",
        ellipsis: true,
        key: "activity_cover",scopedSlots: {customRender: "activity_cover"}
      },  {
        title: "标题",
        dataIndex: "name",
        ellipsis: true,
        key: "name",
      },
      {
            title: "发布时间",
            dataIndex: "release_time",
            ellipsis: true,
            key: "release_time"
        },
        {
            title: "更新时间",
            dataIndex: "update_time",
            ellipsis: true,
            key: "update_time",
        }, {
        title: "送达人数",
        dataIndex: "service_num",
        width: "90px",
        key: "service_num",
      }, {
        title: "打开人数",
        dataIndex: "open_num",
        width: "90px",
        key: "open_num",
      }, {
        title: "打开率",
        dataIndex: "open_rate_format",
        width: "90px",
        key: "open_rate_format",
      },{
        title: "超管送达人数",
        dataIndex: "admin_service_num",
        width: "90px",
        key: "admin_service_num",
      },{
        title: "超管打开人数",
        dataIndex: "admin_open_num",
        width: "90px",
        key: "admin_open_num",
      },{
        title: "超管打开率",
        dataIndex: "admin_open_rate_format",
        width: "85px",
        key: "admin_open_rate_format",
      },

        {
            title: "状态",
            key: "status",
            width: "60px",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
              visibleModal:false,
              emptyText:"",
                resetSeachdata:true,
                seachList:[],
                visibleImg: false,
                tableImg: "",
                seach: {
                    status:"",
                    name: "",
                    update_time: [],
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys:[], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/HotEvents/HotEventsList"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
          deles(){
            let _this=this
            this.$message.destroy()
            if(this.selectedRowKeys.length>0){
              _this.visibleModal=true
              // this.$confirm({
              //   title: '确定要删除吗?',
              //   content: '',
              //   okText: '关闭',
              //   okType: 'primary',
              //   cancelButtonProps: {
              //     props: { disabled: false,type:"primary" },
              //   },
              //   cancelText: '确定',
              //   onOk() {
              //
              //   },
              //   onCancel() {
              //     _this.editLanguage('','5')
              //   },
              // });

            }else{
              this.$message.warning('请至少选择一条数据',2);
            }

          },
          paramsValidate(params) {
            let flag = true;
            for(var key in params){
              if(params[key]!=""&&params[key]!=[]){
                return false;
              }
            }
            return flag;
          },
            add(id) {
                if (id == '') {
                    this.$router.push('/HotEvents/AddHotEvents')
                } else {
                    this.$router.push(`/HotEvents/EditHotEvents?id=${id}`)
                }

            },
            confirm(id) {
                removeById(API.service.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) { this.getList() }
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {
                    status:"",
                    name: "",
                    update_time:this.seach.update_time.length>0?[moment(new Date(), 'YYYY-MM-DD'), moment(new Date(), 'YYYY-MM-DD')]:[],
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                let seachData=JSON.parse(JSON.stringify(this.seach))
                if (seachData.update_time.length > 0&&this.resetSeachdata==true) {
                    seachData.update_time[0] = moment(this.seach.update_time[0]).format('YYYY-MM-DD')
                    seachData.update_time[1] = moment(this.seach.update_time[1]).format('YYYY-MM-DD')
                }else{
                    seachData.update_time=[]
                }
                let _that=this
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.list.data
                    this.seachList=res.data.data.activity_status
                    this.pagination.total = res.data.data.list.total
                    this.pagination.pageSize = res.data.data.list.per_page
                    this.pagination.current = res.data.data.list.current_page
                    if(!this.resetSeachdata==true)this.seach.update_time=[]
                    this.resetSeachdata=true
                    this.loading = false
                  if(this.data.length<1&&_that.paramsValidate(_that.seach)){
                    _that.emptyText="暂无数据"
                  }else{
                    _that.emptyText=`未搜索到数据`
                  }
                })
                this.selectedRowKeys=[]
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            editLanguage(name, type) {
                if (type == '5') {
                    this.confirm(this.selectedRowKeys)
                  this.visibleModal=false
                }
                let url
                let dataArr = []
                let dataJson = {}
                this.selectedRowKeys.map((item, index) => {
                    dataJson = {}
                    dataJson.id = item;
                    dataJson[name] = type;
                    dataArr.push(dataJson)
                })
                if (name == 'status') {
                    changStatus(API.service.CHANG_STATUS,dataArr).then(res => {
                        if (res == true) {
                            this.getList()
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name { width: 70px !important;}
    .seachBox .seachList .seachs { width: calc(100% - 80px);}
    .modal>>>.ant-modal-header{border-bottom: unset!important;padding: 0!important;}
    .modal>>>.ant-modal-footer{border-top: unset!important;}
</style>
